const generateBaseExport = (prefix) => {
	return {
		GET_ALL: prefix + '-GET_ALL',
		FETCHING_ALL: prefix + '-FETCHING_ALL',
		LOADED_ALL: prefix + '-LOADED_ALL',
		ERROR_ALL: prefix + '-ERROR_ALL',
		RESET_ALL: prefix + '-RESET_ALL',
		GET_ONCE: prefix + '-GET_ONCE',
		FETCHING_ONCE: prefix + '-FETCHING_ONCE',
		LOADED_ONCE: prefix + '-LOADED_ONCE',
		ERROR_ONCE: prefix + '-ERROR_ONCE',
		RESET_ONCE: prefix + '-RESET_ONCE',
		FETCHING_DELETE: prefix + '-FETCHING_DELETE',
		LOADED_DELETE: prefix + '-LOADED_DELETE',
		ERROR_DELETE: prefix + '-ERROR_DELETE',
		UPDATE_COLLECTION: prefix + '-UPDATE_COLLECTION',
	};
};

const generateBaseLightExport = (prefix) => {
	return {
		GET: prefix + '-GET',
		FETCHING: prefix + '-FETCHING',
		LOADED: prefix + '-LOADED',
		ERROR: prefix + '-ERROR',
		RESET: prefix + '-RESET',
	};
};


export const CONFIG = {
	...generateBaseLightExport('CONFIG')
};

export const SESSION = {
	...generateBaseLightExport('SESSION'),
	UPDATE_SETUP: 'UPDATE_SETUP',
	UPDATE_NAME: 'UPDATE_NAME',
	...generateBaseExport('SESSION')
};
export const SESSIONS = {
	...generateBaseLightExport('SESSIONS')
};

export const DOMINOES = {
	ADD: 'ADD_DOMINO',
	LOADING: 'LOADING_DOMINO',
	SET: 'SET_DOMINOES',
	ADD_DOMINO_LOCAL: 'ADD_DOMINO_LOCAL'
};

export const GROUPES = {
	LOADING: 'LOADING_DOMINO_GROUP',
	SET_CURRENT: 'SET_DOMINO_GROUP',
	ACTIVE_MOVE: 'ACTIVE_MOVE_GROUP',
	SET_GROUPES: 'SET_GROUPES',
	LOADING_ESTIMATE: 'LOADING_ESTIMATE_DOMINO_GROUP',
	SET_ESTIMATE: 'SET_ESTIMATE_DOMINO_GROUP',
	RESET_ESTIMATE: 'RESET_ESTIMATE_DOMINO_GROUP',
};

export const COLORS = {
	ADD: 'ADD_COLOR',
	SELECT: 'SELECT_COLOR',
	SET: 'SELECT_COLORS',
	LOADING: 'LOADING_COLORS',
	INITIALISED: 'INITIALISED_COLORS'
};

export const SETTINGS = {
	CHANGE_TOOLS: 'CHANGE_TOOLS',
	SAVE_SELECTION: 'SAVE_SELECTION',
	RESET_MODE: 'RESET_MODE',
	CHANGE_MODE: 'CHANGE_MODE'
}
